import { z } from 'zod'

// LLM citation input — unresolved reference the LLM produces
const textAnchorSchema = z
  .string()
  .describe(
    'Short phrase (3–8 words) from the paragraph text that references this source. Must appear verbatim in the paragraph text. Use null when there is no anchor phrase.'
  )
  .nullable()

export const QuestionCitationAgentInputSchema = z.object({
  type: z.literal('question'),
  questionName: z.string().describe('The question name'),
  formTitle: z.string().describe('The form title containing the question'),
  textAnchor: textAnchorSchema,
})

/** Resolved question citation — `textAnchor` is verbatim phrase from the paragraph, or null when none. */
export const QuestionCitationResolvedSchema = z.object({
  sourceType: z.literal('question'),
  sourceLabel: z.string(),
  quote: z.string(),
  questionName: z.string(),
  requestFormId: z.string(),
  formTitle: z.string(),
  textAnchor: z.string().nullable(),
})
export type QuestionCitationResolved = z.infer<typeof QuestionCitationResolvedSchema>
